import { useGlobalState } from '../../../../state/state';
import { Stack, Typography } from '@ace-clublabs/shared-component-library';
import { AdditionalDiscount } from '@lib/types';
import { numberHelper } from '../../../../utils/numberHelper';

export const DiscountsCartItem = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const { inRenewal, inArrears } = memberDetails;
  const additionalDiscounts = memberDetails.memberCosts?.additionalDiscounts as AdditionalDiscount[];

  enum AdditionalDiscountTitle {
    RENEWAL = 'Renewal',
    MEMBERSHIP = 'Membership',
    RETIREE = 'Retiree',
    EMPLOYEE = 'Employee',
    TMOBILE_YOU = 'Year on Us by T-Mobile',
  }

  return (inRenewal || inArrears) && additionalDiscounts.length > 0 ? (
    <Stack gap="0.5rem" marginTop={'1rem'} className="discount-item-container">
      {additionalDiscounts.map((discount, i) => (
        <Stack
          className={`discount-item-${i}`}
          key={i}
          sx={{
            background: '#E9F7DB',
            padding: '0.5rem',
            borderRadius: '0.375rem',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          <Typography variant="b2Regular" fontWeight={700}>
            {AdditionalDiscountTitle[discount.type]} discount applied
          </Typography>
          <Typography variant="b2Regular"> ({numberHelper.formatMoney(discount.value || 0)} value)</Typography>
        </Stack>
      ))}
    </Stack>
  ) : (
    <></>
  );
};
